import { React, useEffect, useLayoutEffect } from "react";
import Header from "./include/Header";
import Footer from "./include/Footer";
import { Link } from "react-router-dom";
import ScrollToTop from "./Component/ScrollTotop";
import "animate.css/animate.min.css";
import config from "../utils/config";
import * as Constant from "../utils/constant";

// Component
import Testimonials from "./Component/Testimonials";
import Insight from "./Component/Insight";
import TechnologyStack from "./Component/TechnologyStack";
import IndustriesFocus from "./Component/IndustriesFocus";
import FeaturedClients from "./Component/FeaturedClients";
import BusinessIdea from "./Component/BusinessIdea";
import GetTouch from "./Component/GetTouch";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import MetaTags from "./Component/MetaTags ";

const bannerPic = "https://images.reactbytes.com/react-bytes/banner-pic.png";
const whatWeDo1 = "https://images.reactbytes.com/react-bytes/what-we-do1.png";
const whatWeDo2 = "https://images.reactbytes.com/react-bytes/what-we-do2.png";
const headsUpPic =
  "https://images.reactbytes.com/react-bytes/headsup-casestudy.jpg";
const investFarPic =
  "https://images.reactbytes.com/react-bytes/invest-far-casestudy.jpg";
const medeloopPic =
  "https://images.reactbytes.com/react-bytes/medeloop-casestudy.jpg";
const HomePage = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (window.innerWidth >= 767) {
      import("wowjs").then((WOW) => {
        const wow = new WOW.WOW();
        if (typeof window !== "undefined") {
          wow.init();
        }
      });
      return () => {};
    }
  }, []);

  const faq = [
    {
      faqQuestion:
        "Do you sign a confidentiality agreement before starting any projects?",
      faqAnswer:
        "Yes, we always sign a confidentiality agreement before starting your project. Protecting your ideas and information is very important to us. This agreement covers how we handle sensitive information, what we can use it for, and how we prevent others from using it. We take your trust seriously and make sure everything stays safe and private.",
    },
    {
      faqQuestion:
        "How do you keep my information and my users' information safe?",
      faqAnswer:
        "We take your data security seriously. We use many layers of security to protect your information and your users' information. This includes encrypting data both when it's stored and when it's sent, following secure coding practices, and regularly checking our security measures. We also follow laws like GDPR to make sure your data is kept private and safe.",
    },
    {
      faqQuestion: "How do you decide how much it costs for your services?",
      faqAnswer:
        "We have different ways to decide the cost for each project. We can offer a fixed price or charge by the hour, depending on what works best for your project. Once we know all the details of what you need, we'll give you a clear list of all the costs involved, so you'll know exactly what to expect and there won't be any surprises.",
    },
    {
      faqQuestion:
        "How will you keep me updated on the progress of the project?",
      faqAnswer:
        "You'll stay updated on your project all along the way. We'll assign a project manager who will keep in touch with you. We believe in being open about our work. We'll give you updates regularly, starting from the beginning of the project to when it's finished. You can expect updates through meetings, reports, and feedback sessions using Email, Skype, Slack, Teams, and Jira. We like to work together with you, making sure you know what's happening and can give your input at every step of the project.",
    },
    {
      faqQuestion:
        "How do you make sure the things you deliver are good quality?",
      faqAnswer:
        "To make sure our apps are high quality, we use methods like testing by hand, automated testing, and continuous integration.",
    },
  ];

  const whyWeLoveReact = [
    {
      iconBg: "icon bg-[#E0FAFF]",
      loveImage: URL.createObjectURL(
        new Blob(
          [
            '<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_151_2071)"><path d="M15.5169 0.0373974C12.0589 0.190866 8.38873 1.67332 5.84506 3.9427C5.31282 4.41617 4.35608 5.40229 3.94465 5.89536C2.91282 7.13617 2.03118 8.65454 1.39445 10.2872C0.228734 13.2749 0.0197548 16.697 0.806694 19.8774C1.73404 23.6227 4.00996 26.9239 7.20669 29.1607C9.04833 30.4505 11.2622 31.3549 13.6328 31.7892C14.2891 31.9068 14.5863 31.9362 15.543 31.9656C17.2998 32.0243 18.3447 31.946 19.6671 31.6619C24.9275 30.5288 29.192 26.9239 31.1969 21.9117C31.752 20.5239 32.1079 19.0349 32.2745 17.4056C32.33 16.8668 32.33 15.1264 32.2745 14.5974C31.9838 11.7729 31.1022 9.32393 29.5479 7.00882C28.983 6.16637 28.5096 5.60801 27.5202 4.62189C26.4459 3.5476 25.6132 2.91413 24.2679 2.14025C21.9659 0.814541 19.6442 0.151682 16.8818 0.034132C16.4802 0.0178051 16.1406 0.00474358 16.121 0.00800896C16.1047 0.00800896 15.8304 0.0243359 15.5169 0.0373974ZM17.721 4.09944C19.4385 4.34107 20.8883 4.8178 22.2271 5.58188C24.4279 6.83903 26.0442 8.57291 27.1447 10.8554C27.7814 12.1811 28.1112 13.3664 28.2679 14.8913C28.3365 15.5541 28.3202 16.9419 28.2385 17.5362C28.1308 18.2839 27.863 19.4137 27.6671 19.9264L27.6312 20.0178H23.974H20.3169V20.2529C20.3169 20.6415 20.1014 21.4023 19.8598 21.8823C19.703 22.186 19.4451 22.5288 19.1447 22.826C18.6842 23.2831 18.214 23.5803 17.6165 23.786C15.9871 24.3476 14.1814 23.786 13.1267 22.3884C12.7153 21.8398 12.3953 20.9909 12.33 20.2725L12.3104 20.0178L8.66302 20.0113L5.01894 20.0015L4.92751 19.7239C3.94139 16.7231 4.19935 13.4186 5.64588 10.5745C6.632 8.62842 8.09812 7.02842 9.9822 5.84311C10.3773 5.59495 11.3667 5.08883 11.7944 4.91903C12.97 4.44883 14.1161 4.16801 15.3536 4.05046C15.8075 4.00801 17.2932 4.0374 17.721 4.09944Z" fill="#0077B6"/><path d="M20.4476 12.4064C20.1831 12.5468 17.9529 14.9729 16.0525 17.1933C14.5603 18.9305 14.348 19.2799 14.3448 19.9852C14.3415 20.6643 14.6354 21.2488 15.1839 21.6407C15.5203 21.879 15.7194 21.9509 16.1407 21.9705C16.8199 21.9999 17.2933 21.8333 17.7048 21.4252C17.9725 21.1574 18.1064 20.9256 18.3578 20.2856C18.8117 19.1492 20.4901 14.1174 20.7284 13.1933C20.8101 12.8701 20.8297 12.5141 20.7741 12.4064C20.7317 12.328 20.5978 12.328 20.4476 12.4064Z" fill="#0077B6"/></g><defs><clipPath id="clip0_151_2071"><rect width="32" height="32" fill="white" transform="translate(0.333252 0.00146484)"/></clipPath></defs></svg>',
          ],
          { type: "image/svg+xml" }
        )
      ),
      title: "Performance",
      discription:
        "React's nature is to offer buttery-smooth UI performance, and we are proud that we deliver the same. Our React Native-based Android and iOS apps enhance the user experience by providing Native app performance.",
      dataDelay: "0.3s",
    },
    {
      iconBg: "icon bg-[#FFF1EE]",
      loveImage: URL.createObjectURL(
        new Blob(
          [
            '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" ><g clipPath="url(#clip0_151_2088)"><path d="M26.7489 0.000488281H3.25389C1.4664 0.000488281 0.00268555 1.46547 0.00268555 3.2543V26.7467C0.00268555 28.5368 1.4664 30.0005 3.25389 30.0005H26.7463C28.5364 30.0005 29.9975 28.5342 29.9975 26.7467V3.2543C30.0014 1.46547 28.5364 0.000488281 26.7489 0.000488281ZM25.9028 2.68893C26.7489 2.68893 27.4383 3.37572 27.4383 4.22443C27.4383 5.07315 26.7528 5.75994 25.9028 5.75994C25.0527 5.75994 24.3673 5.07315 24.3673 4.22443C24.3673 3.37572 25.0554 2.68893 25.9028 2.68893ZM21.1121 2.68766C21.9595 2.68766 22.649 3.37445 22.649 4.22449C22.649 5.07454 21.9608 5.76127 21.1121 5.76127C20.2634 5.76127 19.5753 5.07448 19.5753 4.22443C19.5753 3.37439 20.2647 2.68766 21.1121 2.68766ZM27.5401 27.2102H2.46656V7.96401H27.5401V27.2102Z" fill="#F28482" /><path d="M12.5517 19.1918H7.75586V23.9864H12.5517V19.1918Z" fill="#F28482" /><path d="M22.4451 19.1918H17.6479V23.9864H22.4451V19.1918Z" fill="#F28482" /><path d="M12.5517 11.398H7.75586V16.1913H12.5517V11.398Z" fill="#F28482" /><path d="M22.4451 11.398H17.6479V16.1913H22.4451V11.398Z" fill="#F28482" /></g><defs><clipPath id="clip0_151_2088"><rect width="30" height="30" fill="white" transform="translate(0 0.000488281)" /></clipPath></defs></svg>',
          ],
          { type: "image/svg+xml" }
        )
      ),
      title: "PWA Ready",
      discription:
        "Boost your customer experience and conversions with React-powered PWA the way Trivago, Twitter, Flipkart, and more have been doing. We develop your PWA that serves as a web and mobile app across all browsers and platforms.",
      dataDelay: "0.3s",
    },
    {
      iconBg: "icon bg-[#FFF2DE]",
      loveImage: URL.createObjectURL(
        new Blob(
          [
            '<svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg" ><path fillRule="evenodd" clipRule="evenodd" d="M13.4446 21.3036L20.937 25.8914C21.4877 26.2297 22.1688 25.7297 22.0239 25.0974L20.0385 16.4512L26.6469 10.6429C27.1251 10.2164 26.8788 9.4077 26.2266 9.34888L17.5169 8.59895L14.1112 0.452652C13.8648 -0.150233 13.0243 -0.150233 12.7779 0.452652L9.37228 8.59895L0.662515 9.34888C0.0248619 9.4077 -0.235996 10.2164 0.256736 10.6429L6.86515 16.4512L4.87972 25.0974C4.7348 25.7297 5.41593 26.2297 5.96663 25.8914L13.4446 21.3036Z" fill="#FF6D00" /></svg>',
          ],
          { type: "image/svg+xml" }
        )
      ),
      title: "Truested By Big Brands",
      discription:
        "Leading brands such as Facebook, Instagram, Walmart, Airbnb, Wix, Skype, and more have excelled in providing extraordinary user experience using React.js and React Native. It's time you get on to it now.",
      dataDelay: "0.3s",
    },
    {
      iconBg: "icon bg-[#F8EFFF]",
      loveImage: URL.createObjectURL(
        new Blob(
          [
            '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.7489 0.000488281H3.25389C1.4664 0.000488281 0.00268555 1.46547 0.00268555 3.2543V26.7467C0.00268555 28.5368 1.4664 30.0005 3.25389 30.0005H26.7463C28.5364 30.0005 29.9975 28.5342 29.9975 26.7467V3.2543C30.0014 1.46547 28.5364 0.000488281 26.7489 0.000488281ZM25.9028 2.68893C26.7489 2.68893 27.4383 3.37572 27.4383 4.22443C27.4383 5.07315 26.7528 5.75994 25.9028 5.75994C25.0527 5.75994 24.3673 5.07315 24.3673 4.22443C24.3673 3.37572 25.0554 2.68893 25.9028 2.68893ZM21.1121 2.68766C21.9595 2.68766 22.649 3.37445 22.649 4.22449C22.649 5.07454 21.9608 5.76127 21.1121 5.76127C20.2634 5.76127 19.5753 5.07448 19.5753 4.22443C19.5753 3.37439 20.2647 2.68766 21.1121 2.68766ZM27.5401 27.2102H2.46656V7.96401H27.5401V27.2102Z" fill="#9D4EDD"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M20.1536 18.1375C20.1796 17.9295 20.1991 17.7215 20.1991 17.5005C20.1991 17.2795 20.1796 17.0715 20.1536 16.8635L21.5251 15.791C21.6486 15.6935 21.6811 15.518 21.6031 15.375L20.3031 13.126C20.2251 12.983 20.0496 12.931 19.9066 12.983L18.2881 13.633C17.9501 13.373 17.5861 13.1585 17.1896 12.996L16.9426 11.2735C16.9231 11.1175 16.7866 11.0005 16.6241 11.0005H14.0241C13.8616 11.0005 13.7251 11.1175 13.7056 11.2735L13.4586 12.996C13.0621 13.1585 12.6981 13.3795 12.3601 13.633L10.7416 12.983C10.5921 12.9245 10.4231 12.983 10.3451 13.126L9.04507 15.375C8.96057 15.518 8.99957 15.6935 9.12307 15.791L10.4946 16.8635C10.4686 17.0715 10.4491 17.286 10.4491 17.5005C10.4491 17.715 10.4686 17.9295 10.4946 18.1375L9.12307 19.21C8.99957 19.3075 8.96707 19.483 9.04507 19.626L10.3451 21.875C10.4231 22.018 10.5986 22.07 10.7416 22.018L12.3601 21.368C12.6981 21.628 13.0621 21.8425 13.4586 22.005L13.7056 23.7275C13.7251 23.8835 13.8616 24.0005 14.0241 24.0005H16.6241C16.7866 24.0005 16.9231 23.8835 16.9426 23.7275L17.1896 22.005C17.5861 21.8425 17.9501 21.6215 18.2881 21.368L19.9066 22.018C20.0561 22.0765 20.2251 22.018 20.3031 21.875L21.6031 19.626C21.6811 19.483 21.6486 19.3075 21.5251 19.21L20.1536 18.1375ZM15.3241 19.7755C14.0696 19.7755 13.0491 18.755 13.0491 17.5005C13.0491 16.246 14.0696 15.2255 15.3241 15.2255C16.5786 15.2255 17.5991 16.246 17.5991 17.5005C17.5991 18.755 16.5786 19.7755 15.3241 19.7755Z" fill="#9D4EDD"></path></svg>',
          ],
          { type: "image/svg+xml" }
        )
      ),
      title: "Easy to Manage & Maintain",
      discription:
        "React Native allows us to write code only once for both- Android and iOS apps. Using JavaScript for developing back-end and front-end makes managing and maintaining the code smoother than ever.",
      dataDelay: "0.4s",
    },
    {
      iconBg: "icon bg-[#DCFFFB]",
      loveImage: URL.createObjectURL(
        new Blob(
          [
            '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.762 3.88664C13.6462 2.60714 14.5957 1.28582 15.9472 0.466637C17.2799 1.26551 18.2201 2.56332 19.0917 3.82014C21.1446 6.92976 22.3997 10.6648 22.1465 14.4188C22.81 14.9749 23.4926 15.5088 24.1462 16.0763C25.0844 16.9386 25.5224 18.2838 25.2965 19.5343C24.9818 21.1139 24.6793 22.6972 24.3462 24.2726C24.161 25.0831 23.0644 25.4541 22.4197 24.9363C21.3497 24.0431 20.3062 23.1171 19.2365 22.2228C18.4271 23.0016 17.3519 23.521 16.2231 23.5836C14.9237 23.6752 13.6372 23.1363 12.6951 22.2559C11.9276 22.8435 11.216 23.5488 10.4661 24.1781C10.1037 24.4694 9.8023 24.8521 9.37336 25.051C8.70836 25.3363 7.85199 24.9105 7.70167 24.1957C7.35924 22.6556 7.00149 21.1182 6.66917 19.5757C6.39911 18.2708 6.87742 16.8501 7.88286 15.9753C8.46492 15.4864 9.05511 15.0073 9.64805 14.5318C9.81324 14.4449 9.73024 14.2445 9.73961 14.0973C9.56286 10.4754 10.8 6.89532 12.762 3.88664ZM13.8122 8.65739C13.0357 9.65701 13.1297 11.2054 14.0302 12.0981C14.9837 13.1487 16.7896 13.187 17.7869 12.1788C18.5567 11.4754 18.817 10.2946 18.4495 9.32432C18.1129 8.38889 17.2115 7.68714 16.2201 7.59989C15.3046 7.49451 14.3567 7.9157 13.8122 8.65739Z" fill="#07BEB8"></path><path d="M12.3914 25.4882C12.3781 25.0341 12.9433 24.7218 13.3253 24.9621C14.9421 25.7946 16.952 25.7943 18.5688 24.9617C18.9398 24.7339 19.4898 25.0075 19.5035 25.4494C19.5089 26.4139 19.51 27.3794 19.505 28.3442C19.5124 28.815 18.8905 29.1153 18.5249 28.8208C18.2466 28.5754 17.9957 28.2995 17.728 28.042C17.3045 28.8671 16.9053 29.7046 16.4783 30.5278C16.2733 30.92 15.6325 30.9226 15.4235 30.5343C14.9941 29.7096 14.5977 28.8671 14.166 28.0432C13.9021 28.303 13.6505 28.5774 13.3726 28.8224C13.0086 29.1183 12.3878 28.8123 12.3929 28.3445C12.3851 27.3927 12.3902 26.4405 12.3914 25.4882Z" fill="#07BEB8"></path><path d="M15.927 11.5821C16.6454 11.5821 17.2277 10.9997 17.2277 10.2813C17.2277 9.56294 16.6454 8.98058 15.927 8.98058C15.2086 8.98058 14.6262 9.56294 14.6262 10.2813C14.6262 10.9997 15.2086 11.5821 15.927 11.5821Z" fill="#07BEB8"></path></svg>',
          ],
          { type: "image/svg+xml" }
        )
      ),
      title: "Faster Time-to-Market",
      discription:
        "Our expert React Native developers use a single code to build iOS and Android apps, which ultimately speeds up your time-to-market process. Get your marketing strategy streamlined by the time we deliver your apps.",
      dataDelay: "0.4s",
    },
    {
      iconBg: "icon bg-[#EFF4FF]",
      loveImage: URL.createObjectURL(
        new Blob(
          [
            '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_151_2135)"><g clip-path="url(#clip1_151_2135)"><path d="M15.6607 10.7758C17.5438 12.2392 18.9534 14.4306 19.3601 16.7995C19.3938 17.3492 19.3897 17.8988 19.3901 18.4495C19.392 18.5954 19.394 18.7414 19.396 18.8917C19.4015 21.4542 18.3103 23.6263 16.612 25.5045C14.5058 27.5717 11.9894 28.2278 9.12181 28.2177C6.81355 28.178 4.7103 27.3158 2.99384 25.7333C0.879008 23.4639 -0.117917 21.0315 -0.0380385 17.9633C0.0666838 15.6387 1.04918 13.3742 2.66759 11.6889C6.46393 8.33206 11.4293 7.804 15.6607 10.7758ZM7.76009 11.0995C7.53486 11.1608 7.53486 11.1608 7.30509 11.2233C6.92427 11.3453 6.5908 11.4893 6.24009 11.6795C6.29289 11.7752 6.34569 11.8709 6.40009 11.9695C6.56009 12.3195 6.56009 12.3195 6.56009 12.7995C6.34889 12.8523 6.13769 12.9051 5.92009 12.9595C5.81449 12.6955 5.70889 12.4315 5.60009 12.1595C4.69187 12.6136 3.68685 13.4192 3.36009 14.3995C3.51849 14.5035 3.51849 14.5035 3.68009 14.6095C3.78569 14.6986 3.89129 14.7877 4.00009 14.8795C4.00009 15.0379 4.00009 15.1963 4.00009 15.3595C3.57769 15.3067 3.15529 15.2539 2.72009 15.1995C2.61159 15.4989 2.50537 15.799 2.40009 16.0995C2.34069 16.2666 2.28129 16.4336 2.22009 16.6058C2.07931 17.1224 2.05451 17.5471 2.08009 18.0795C2.39689 18.1323 2.71369 18.1851 3.04009 18.2395C3.04009 18.4507 3.04009 18.6619 3.04009 18.8795C2.56489 18.9587 2.56489 18.9587 2.08009 19.0395C2.12599 20.1595 2.32073 20.9452 2.88009 21.9195C3.43449 21.8403 3.43449 21.8403 4.00009 21.7595C4.00009 22.2395 4.00009 22.2395 3.68009 22.5895C3.57449 22.6852 3.46889 22.7809 3.36009 22.8795C4.00572 23.6493 4.64723 24.3407 5.44009 24.9595C5.68675 24.7395 5.68675 24.7395 5.92009 24.4795C5.92009 24.3739 5.92009 24.2683 5.92009 24.1595C6.13129 24.2123 6.34249 24.2651 6.56009 24.3195C6.46795 24.7012 6.36452 25.0662 6.24009 25.4395C7.30027 25.9353 8.10788 26.1551 9.28009 26.0795C9.33289 25.7627 9.38569 25.4459 9.44009 25.1195C9.59849 25.1195 9.75689 25.1195 9.92009 25.1195C9.99929 25.6739 9.99929 25.6739 10.0801 26.2395C11.2048 26.1669 12.0937 25.9002 13.1201 25.4395C12.9617 24.8059 12.9617 24.8059 12.8001 24.1595C13.4401 24.3195 13.4401 24.3195 13.6401 24.6495C13.6797 24.7518 13.7193 24.8541 13.7601 24.9595C14.7688 24.5014 15.6733 23.7234 16.1601 22.7195C16.0281 22.6502 15.8961 22.5809 15.7601 22.5095C15.6281 22.4204 15.4961 22.3313 15.3601 22.2395C15.3601 22.0811 15.3601 21.9227 15.3601 21.7595C15.7825 21.8123 16.2049 21.8651 16.6401 21.9195C17.2061 20.5223 17.2061 20.5223 17.2801 19.0395C16.9633 18.9339 16.6465 18.8283 16.3201 18.7195C16.3201 18.5611 16.3201 18.4027 16.3201 18.2395C16.6369 18.1867 16.9537 18.1339 17.2801 18.0795C17.3619 16.9749 17.0992 16.1998 16.6401 15.1995C16.0065 15.2787 16.0065 15.2787 15.3601 15.3595C15.3601 15.2011 15.3601 15.0427 15.3601 14.8795C15.7601 14.6095 15.7601 14.6095 16.1601 14.3995C15.5669 13.5434 14.9499 12.7514 14.0801 12.1595C13.9745 12.1595 13.8689 12.1595 13.7601 12.1595C13.7007 12.313 13.7007 12.313 13.6401 12.4695C13.4401 12.7995 13.4401 12.7995 12.8001 12.9595C12.9057 12.5371 13.0113 12.1147 13.1201 11.6795C12.1068 11.1533 11.2203 10.9271 10.0801 10.8795C10.0273 11.2491 9.97449 11.6187 9.92009 11.9995C9.76169 11.9467 9.60329 11.8939 9.44009 11.8395C9.36089 11.3643 9.36089 11.3643 9.28009 10.8795C8.70205 10.8795 8.30939 10.9471 7.76009 11.0995Z" fill="#0077B6"></path><path d="M7.84004 15.1995C7.99844 15.1995 8.15683 14.9635 8.32003 14.9635C8.60081 15.4458 8.83391 16.179 9.07129 16.6839C9.45935 17.1423 9.54516 17.2064 10.1057 17.3095C11.01 17.3516 11.6264 16.9613 12.37 16.4895C12.6187 16.3369 12.8681 16.1854 13.1182 16.0352C13.2263 15.9671 13.4593 15.899 13.5707 15.8289C13.8848 15.6795 13.7684 15.8289 14.4084 15.8289C14.3703 16.2024 14.3619 16.053 14.24 16.4795C13.9479 16.7141 13.9479 16.7141 13.5707 16.9033C13.4355 16.9751 13.3003 17.0468 13.161 17.1208C12.8747 17.2661 12.588 17.4107 12.301 17.5545C11.5582 17.9203 11.5582 17.9203 11.0426 18.5344C10.9464 18.8701 10.9464 18.8701 10.88 19.3595C10.492 19.8051 10.2718 19.8356 9.68004 19.9095C9.12004 19.8395 9.12004 19.8395 8.74004 19.5895C8.40086 19.0808 8.35255 18.6863 8.32004 18.0795C8.35407 17.977 8.38811 17.8745 8.42317 17.7689C8.52115 17.2014 7.85821 16.1401 7.55705 15.6795C7.35293 15.221 7.557 15.4361 7.84004 15.1995Z" fill="#090909"></path><path d="M26.6875 19.9995C26.9144 19.9995 27.1413 19.9995 27.375 19.9995C27.375 20.1628 27.375 20.5117 27.375 20.6799C27.5452 20.6799 27.8247 20.6799 28 20.6799C28 20.8977 28 21.1154 28 21.3397C27.8298 21.3397 27.5503 21.3397 27.375 21.3397C27.375 21.5574 27.375 21.7752 27.375 21.9995C27.1481 21.9995 26.9213 21.9995 26.6875 21.9995C26.6875 21.7818 26.6875 21.564 26.6875 21.3397C26.4606 21.3397 26.2338 21.3397 26 21.3397C26 21.122 26 20.9042 26 20.6799C26.2269 20.6799 26.4538 20.6799 26.6875 20.6799C26.6875 20.5166 26.6875 20.1678 26.6875 19.9995Z" fill="black"></path><path d="M26 23.9995C26.66 23.9995 27.32 23.9995 28 23.9995C28 24.1579 28 24.3163 28 24.4795C27.34 24.4795 26.68 24.4795 26 24.4795C26 24.3211 26 24.1627 26 23.9995Z" fill="#0077B6"></path><circle cx="9.33333" cy="18.6675" r="1.33333" fill="#090909"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M14.0756 3.65427L13.6419 3.65704C12.871 3.65998 12.5423 3.90479 11.9256 4.37639C11.2923 5.05475 11.1468 5.72113 11.1567 6.61568L11.17 7.01951L11.2 8.31951L14.08 9.11951L14.11 8.11951C14.1106 8.09921 14.1112 8.07922 14.1117 8.05955C14.1292 7.46181 14.1384 7.14764 14.5664 6.69187C15.0614 6.38625 15.3917 6.32388 15.9686 6.3181L16.3301 6.32432C16.735 6.3232 17.1397 6.32306 17.5445 6.32695C17.8337 6.32992 18.1229 6.33178 18.412 6.33256C19.015 6.33313 19.618 6.33447 20.221 6.33866C21.0054 6.34501 21.7898 6.35051 22.5743 6.35228C23.3336 6.35378 24.0928 6.35607 24.8521 6.35941L25.2868 6.36139C25.7072 6.36298 26.1276 6.36484 26.5479 6.368L26.9319 6.37119C27.0075 6.37146 27.0812 6.371 27.1535 6.37056C27.7423 6.36691 28.2303 6.36389 28.7356 6.75986C28.8992 7.10919 28.9828 7.2878 29.0213 7.47565C29.0615 7.67218 29.0523 7.87884 29.0334 8.3017L29.03 8.78951L29.0396 9.27545L29.0393 9.74389C29.0473 9.96101 29.0511 10.0669 29.0402 10.1712C29.0299 10.2705 29.0062 10.3684 28.96 10.5595C28.6031 11.0297 28.413 11.1839 27.8239 11.2825L27.2339 11.2869C26.8918 11.2921 26.5499 11.2964 26.2077 11.2968C25.9635 11.2969 25.7193 11.2982 25.4751 11.3006C24.8351 11.3082 24.195 11.3137 23.5549 11.3162C22.8916 11.3186 22.2284 11.3238 21.5651 11.3301C20.275 11.3426 18.9849 11.3517 17.6948 11.3577C17.6237 11.358 17.4827 11.3583 17.3427 11.3586C17.2048 11.3589 17.0679 11.3592 17 11.3595C17.1168 11.3591 17.44 11.6795 17.7075 12.0283C19.0935 13.826 19.6227 15.6086 20.0481 17.802L20.16 18.3995C20.8494 18.0356 21.2923 17.8339 22.08 17.9195C22.1816 17.9524 22.2752 17.99 22.3622 18.0322C23.2939 18.2027 24 19.0186 24 19.9995C24 21.1041 23.1046 21.9995 22 21.9995C21.1668 21.9995 20.4527 21.4901 20.152 20.7657L19.84 20.4795C19.6291 21.2315 19.4089 21.979 19.1583 22.7188C18.3607 24.88 16.5187 26.6534 14.48 27.6495C14.3401 27.7127 14.2406 27.7714 14.137 27.8324C13.9174 27.9619 13.6796 28.102 13 28.3195C14.9449 28.3229 17.4897 28.3256 19.4346 28.3273L19.6655 28.3275C20.5795 28.3282 21.4935 28.329 22.4075 28.3305C23.3789 28.3323 24.3503 28.3338 25.3217 28.3344L26.4281 28.3351C26.9605 28.3364 27.4929 28.3376 28.0254 28.3377L28.5127 28.3377L28.9744 28.3394L29.3966 28.3388C30.2557 28.3398 30.7208 28.0963 31.36 27.5195C32.0537 26.7555 32.0751 26.117 32.0814 25.1033L32.0752 24.5169C32.0763 23.8633 32.0769 23.2099 32.0725 22.5565C32.0685 21.971 32.0671 21.3857 32.0667 20.8002C32.0661 19.82 32.0638 18.8397 32.059 17.8594C32.0525 16.5913 32.0483 15.3231 32.0467 14.055C32.0454 12.9562 32.0431 11.8574 32.0401 10.7586L32.0381 10.057C32.0365 9.37769 32.0348 8.69837 32.0315 8.01905L32.0283 7.39935L32.027 6.80896L32.0235 6.27333C32.0197 5.41553 31.8286 5.09234 31.3031 4.40514C30.5703 3.72109 29.8366 3.62391 28.8776 3.61801L28.4045 3.62248C27.8755 3.62144 27.3466 3.62114 26.8177 3.62387C26.4398 3.62597 26.0619 3.62725 25.684 3.62774C24.8964 3.62798 24.1088 3.62882 23.3212 3.6318C22.2961 3.63635 21.271 3.6402 20.2458 3.64107C19.4458 3.64163 18.6457 3.64256 17.8457 3.64425L16.7025 3.64701C16.153 3.64789 15.6035 3.64898 15.0541 3.65132L14.5526 3.65373L14.0756 3.65427ZM22 16.9995C23.1046 16.9995 24 16.1041 24 14.9995C24 13.8949 23.1046 12.9995 22 12.9995C20.8954 12.9995 20 13.8949 20 14.9995C20 16.1041 20.8954 16.9995 22 16.9995ZM27 17.9995C25.8954 17.9995 25 18.8949 25 19.9995V24.9995C25 26.1041 25.8954 26.9995 27 26.9995C28.1046 26.9995 29 26.1041 29 24.9995V19.9995C29 18.8949 28.1046 17.9995 27 17.9995ZM29 14.9995C29 16.1041 28.1046 16.9995 27 16.9995C25.8954 16.9995 25 16.1041 25 14.9995C25 13.8949 25.8954 12.9995 27 12.9995C28.1046 12.9995 29 13.8949 29 14.9995ZM24 24.9995C24 26.1041 23.1046 26.9995 22 26.9995C20.8954 26.9995 20 26.1041 20 24.9995C20 23.8949 20.8954 22.9995 22 22.9995C23.1046 22.9995 24 23.8949 24 24.9995Z" fill="#0077B6"></path></g></g><defs><clipPath id="clip0_151_2135"><rect width="32" height="32" fill="white" transform="translate(0 -0.000488281)"></rect></clipPath><clipPath id="clip1_151_2135"><rect width="32" height="32" fill="white" transform="translate(0 -0.000488281)"></rect></clipPath></defs></svg>',
          ],
          { type: "image/svg+xml" }
        )
      ),
      title: "Cost Effective",
      discription:
        "Not just our developers at ReactBytes, but even bigger brands love React because it not only offers super-awesome app performance and user experience, but also saves development hours and costs for two mobile apps.",
      dataDelay: "0.4s",
    },
  ];

  return (
    <>
      <div className="pageHeader">
        <Header />
        <MetaTags
          title="ReactJS Development Company, React Native Development Services for Web and Mobile"
          description="We are ReactJS Development Company based in India, offers React Native Development and ReactJS Development Services for Websites and Mobile Apps. Get a Free Quote and Hire ReactJS Expert from ReactBytes."
          keywords="ReactJS Development Company, React Native Development, ReactJS Development Services, ReactJS for Web Development"
          ogImage={config.LIVE_IMAGE_BASE_URL + "landing-page-og-img.jpg"}
          ogURL={Constant.WEBSITE_URL}
          author={Constant.WEBSITE_AUTHOR_URL}
          facebookURL={Constant.FACEBOOK_URL}
          twitterSite={Constant.TWITTER_PAGE_CREATOR}
          twitterCreator={Constant.TWITTER_PAGE_CREATOR}
        ></MetaTags>
        <div className="container mx-auto px-4">
          <div className="home-banner">
            <div className="banner-info text-center">
              <h1>React App Development Agency</h1>
              <p>
                Transforming Digital Solutions using React.js and React Native
              </p>
              <Link
                to={process.env.PUBLIC_URL + "/contact-us"}
                className="default-btn"
              >
                Contact Us
              </Link>
            </div>
            <img src={bannerPic} alt="Banner" className="mx-auto max-w-full" />
          </div>
        </div>
      </div>
      <div className="py-[40px] md:py-[60px] lg:py-[80px]">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h2
              className="section-title wow animate__animated animate__fadeInUp"
              data-wow-delay="0.3s"
            >
              What We Do
            </h2>
            <div
              className="section-sub-title wow animate__animated animate__fadeInUp"
              data-wow-delay="0.4s"
            >
              We eat, sleep, breathe React as that's what we do best. We codify
              your ideas into React-
              <br />
              powered, functionally-rich, and super-engaging mobile apps.
            </div>
          </div>
          <div className="flex flex-col md:flex-row items-center gap-[20px] md:gap-[40px] lg:gap-[60px] xl:gap-[100px] py-[40px] md:py-[60px] lg:py-[80px]">
            <div className="w-full md:w-1/2">
              <img src={whatWeDo1} alt="" className="max-w-full" />
            </div>
            <div className="w-full md:w-1/2">
              <div className="whatwedo-info">
                <h3>React.js Development</h3>
                <p>
                  Get UI-powered single-page applications using React.js, the
                  world's most powerful JavaScript library. We help you build
                  super-fast, engaging, and interactive user interfaces that
                  even your competitors will regret.
                </p>
                <Link
                  to={process.env.PUBLIC_URL + "/reactjs-development"}
                  className="btn-black"
                >
                  Read More
                </Link>
              </div>
            </div>
          </div>
          <div className="flex flex-col md:flex-row items-center gap-[20px] md:gap-[40px] lg:gap-[60px] xl:gap-[100px]">
            <div className="w-full md:w-1/2 order-2 md:order-first">
              <div className="whatwedo-info">
                <h3>React Native Development</h3>
                <p>
                  Our expert React Native developers build high-performing
                  native mobile apps for iOS and Android devices. Follow the
                  leaders in the React Native league now- Facebook, Instagram,
                  AirBnB, Myntra, and more.
                </p>
                <Link
                  to={process.env.PUBLIC_URL + "/react-native-development"}
                  className="btn-black"
                >
                  Read More
                </Link>
              </div>
            </div>
            <div className="w-full md:w-1/2 order-1 md:order-last">
              <img src={whatWeDo2} alt="" className="max-w-full" />
            </div>
          </div>
        </div>
      </div>
      <div className="py-[40px] md:py-[60px] lg:py-[80px] bg-linear-gray">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div
              className="section-title wow animate__animated animate__fadeInUp"
              data-wow-delay="0.3s"
            >
              Why We Love React
            </div>
            <div
              className="section-sub-title wow animate__animated animate__fadeInUp"
              data-wow-delay="0.4s"
            >
              Our developers are obsessed with the React features and the
              benefits of developing
              <br /> Mobile and Web apps using React.js and React Native.
            </div>
          </div>
          <div className="flex flex-wrap mt-[40px] lg:mt-[60px] gap-[20px] xl:gap-[30px]">
            {whyWeLoveReact.map((data, i) => (
              <div
                className="love-react-box wow animate__animated animate__fadeInUp"
                data-wow-delay={data.dataDelay}
                key={i}
              >
                <div className={data.iconBg}>
                  <img src={data.loveImage} alt="" />
                </div>
                <div className="love-react-info">
                  <h3>{data.title}</h3>
                  <p>{data.discription}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 pb-[60px] lg:pb-[80px]">
        <div className="develop-personalized">
          <h3 className="section-title !text-white">
            Develop Personalized Software Solutions
          </h3>
          <p className="section-sub-title mb-6 lg:mb-10 !text-white">
            Let's validate your idea. Together, we create software that is
            feature-rich and scalable.
          </p>
          <Link
            to={process.env.PUBLIC_URL + "/contact-us"}
            className="btn-black !px-6 btn-hover-white"
          >
            Inquire Now{" "}
            <svg
              className="ml-4"
              width="43"
              height="20"
              viewBox="0 0 43 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.4062 1.49951L41.4062 9.99951L32.4062 18.4995"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M40.5938 9.99951H1.59375"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      </div>
      <FeaturedClients />
      <div className="py-[40px] md:py-[60px] lg:py-[80px]">
        <div className="container mx-auto px-4">
          <div className="text-center lg:mb-[30px]">
            <div
              className="section-title wow animate__animated animate__fadeInUp"
              data-wow-delay="0.3s"
            >
              Our Recent Work
            </div>
            <div
              className="section-sub-title !mt-2 wow animate__animated animate__fadeInUp"
              data-wow-delay="0.4s"
            >
              Explore our latest projects, testaments to our commitment to
              delivering transformative digital solutions.
            </div>
          </div>
          <div className="our-recent-work-row bg-[#EAF8FF]">
            <div className="our-recent-work-info flex-1">
              <span>HeadsUp Head</span>
              <h3>Health & Fitness</h3>
              <p>
                HeadsUp is a complete combination of Web and Mobile Apps to
                track all your Health Records no matter if it is a Medical
                Record or Workout Records or Day to Day activities.
              </p>
              <ul>
                <li>React Native</li>
                <li>Node.Js</li>
                <li>React.Js</li>
                <li>AI/ML</li>
                <li>Amazon AWS</li>
                <li>iPhone</li>
                <li>Android</li>
                <li>Web</li>
              </ul>
              <Link
                to={process.env.PUBLIC_URL + "/casestudy/headsup"}
                className="view-case-study"
              >
                View Case Study
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.05022 21.1918C7.44074 21.5824 8.07391 21.5824 8.46443 21.1918L16.9497 12.7065C17.3402 12.316 17.3402 11.6829 16.9497 11.2923L8.46443 2.80705C8.07391 2.41653 7.44074 2.41653 7.05022 2.80705C6.65969 3.19758 6.65969 3.83074 7.05022 4.22127L14.8284 11.9994L7.05022 19.7776C6.65969 20.1681 6.65969 20.8013 7.05022 21.1918Z"
                    fill="#0E1013"
                  />
                </svg>
              </Link>
            </div>
            <div className="our-recent-work-pic flex-1 relative z-[1]">
              <img
                src={headsUpPic}
                alt=""
                className="max-w-full rounded-[2px]"
              />
            </div>
          </div>
          <div className="our-recent-work-row bg-[#EFF2F3]">
            <div className="our-recent-work-info flex-1">
              <span>Invest Far</span>
              <h3>Complete Real Estate Solution</h3>
              <p>
                Find an area to invest, get consultation, acquire a property,
                find contractors, and manage/relist the property.
              </p>
              <ul>
                <li>React Native</li>
                <li>React.Js</li>
                <li>Stripe</li>
                <li>Amazon</li>
              </ul>
              <Link
                to={process.env.PUBLIC_URL + "/casestudy/investfar"}
                className="view-case-study"
              >
                View Case Study
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.05022 21.1918C7.44074 21.5824 8.07391 21.5824 8.46443 21.1918L16.9497 12.7065C17.3402 12.316 17.3402 11.6829 16.9497 11.2923L8.46443 2.80705C8.07391 2.41653 7.44074 2.41653 7.05022 2.80705C6.65969 3.19758 6.65969 3.83074 7.05022 4.22127L14.8284 11.9994L7.05022 19.7776C6.65969 20.1681 6.65969 20.8013 7.05022 21.1918Z"
                    fill="#0E1013"
                  />
                </svg>
              </Link>
            </div>
            <div className="our-recent-work-pic flex-1 relative z-[1]">
              <img
                src={investFarPic}
                alt=""
                className="max-w-full rounded-[2px]"
              />
            </div>
          </div>
          <div className="our-recent-work-row bg-[#E2FBFA]">
            <div className="our-recent-work-info flex-1">
              <span>Medeloop</span>
              <h3>Revolutionize Health Research</h3>
              <p>
                Medeloop accelerates breakthrough discoveries through novel deep
                AI model explainability techniques built on top of a
                comprehensive data linkage infrastructure.
              </p>
              <ul>
                <li>React Js</li>
                <li>Node Js</li>
                <li>Swift</li>
                <li>SwiftUI</li>
                <li>iPhone</li>
              </ul>
              <Link to={""} className="view-case-study">
                View Case Study
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.05022 21.1918C7.44074 21.5824 8.07391 21.5824 8.46443 21.1918L16.9497 12.7065C17.3402 12.316 17.3402 11.6829 16.9497 11.2923L8.46443 2.80705C8.07391 2.41653 7.44074 2.41653 7.05022 2.80705C6.65969 3.19758 6.65969 3.83074 7.05022 4.22127L14.8284 11.9994L7.05022 19.7776C6.65969 20.1681 6.65969 20.8013 7.05022 21.1918Z"
                    fill="#0E1013"
                  />
                </svg>
              </Link>
            </div>
            <div className="our-recent-work-pic flex-1 relative z-[1]">
              <img
                src={medeloopPic}
                alt=""
                className="max-w-full rounded-[2px]"
              />
            </div>
          </div>
          <div className="text-center mt-[40px] lg:mt-[60px]">
            <Link to={"/portfolio"} className="btn-black">
              See More Portfolio
            </Link>
          </div>
        </div>
      </div>
      <TechnologyStack />
      <Testimonials />
      <IndustriesFocus />
      <Insight />
      <BusinessIdea />
      <div className="pt-[60px] lg:pt-[80px] md:pb-[140px] lg:pb-[160px]">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div
              className="section-title wow animate__animated animate__fadeInUp"
              data-wow-delay="0.3s"
            >
              Frequently Asked Questions
            </div>
          </div>
          <div className="faq-section">
            {faq.map((data, i) => (
              <Accordion className="accordion-row" key={i}>
                <AccordionSummary
                  expandIcon={<div className="accordion-icon"></div>}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  {data.faqQuestion}
                </AccordionSummary>
                <AccordionDetails>
                  <p>{data.faqAnswer}</p>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </div>
      </div>
      <GetTouch />
      <ScrollToTop />
      <Footer />
    </>
  );
};

export default HomePage;
